import React, { useState } from "react";
import { productDropDownData } from "../../constants";
import {
  ProductContainer,
  Product,
  ProductIconWrapper,
  IoTriangleSharpStyle,
} from "./ProductDropDown.styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";
import OutsideClickHandler from "../OutsideClickHandler/OutsideClickHandler";
interface ProductDropDownProps {
  setShowDiv: (state: boolean) => void;
  showDiv: boolean;
}
const ProductDropDownComponent: React.FC<ProductDropDownProps> = ({
  setShowDiv,
  showDiv,
}) => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <OutsideClickHandler
      showDiv={setShowDiv}
      show={showDiv}
      className={"outsideClick"}
    >
      <ProductContainer
        onMouseEnter={(e) => e.stopPropagation()}
        // onClick={closeProductDropDown}
      >
        <IoTriangleSharpStyle />
        {productDropDownData.map((product) => (
          <Product key={product.id}>
            <ProductIconWrapper>
              <img src={product.icon} />
            </ProductIconWrapper>
            <p>{t(product.label, { lng: currentLocale })}</p>
          </Product>
        ))}
      </ProductContainer>
    </OutsideClickHandler>
  );
};

export default ProductDropDownComponent;
